/**
 * Returns IANA-formatted timezone (i.e., `America/Chicago`),
 * or `undefined` if `Intl` API is unsupported
 */
export function timezone(): string|undefined {
	return window['Intl']
		? Intl.DateTimeFormat().resolvedOptions().timeZone
		: undefined
	;
}
